import Cookies from 'js-cookie';

export const REGULAR_TESTS_COOKIE_NAME = 'abst';
export const FORCED_TESTS_COOKIE_NAME = 'abst-forced';

export const TEST_GROUP_TYPES = ['a', 'b', 'c'];

const TEST_PARTS_SEPARATOR = '_';
const TEST_ITEMS_SEPARATOR = ',';

/**
 * Ключ тестовой группы, состоящий из идентификатора теста
 * и идентификатора типа группы, разделенных нижним подчеркиванием
 * @example h59_b
 */
export type ABTest = string;

export const isTestValid = (value: string): value is ABTest => /^[A-Za-z0-9]+_[abc]$/.test(value);

export const getTests = (cookieName: string): ABTest[] =>
  (Cookies.get(cookieName) || '').split(TEST_ITEMS_SEPARATOR).filter(isTestValid);

export const setTests = (cookieName: string, tests: ABTest[]): void => {
  Cookies.set(cookieName, tests.join(TEST_ITEMS_SEPARATOR), { expires: 7 });
};

export const removeTests = (cookieName: string): void => {
  Cookies.remove(cookieName);
};

export const extractTestName = (test: ABTest): string => test.split(TEST_PARTS_SEPARATOR)[0];
export const extractTestGroupType = (test: ABTest): string => test.split(TEST_PARTS_SEPARATOR)[1];

export const buildTest = (name: string, groupType: string): ABTest => {
  const test = name + TEST_PARTS_SEPARATOR + groupType;

  if (!isTestValid(test)) {
    throw new Error('Неверный формат названия теста или типа группы');
  }

  return test;
};
